"use strict";
/*
 * Created on 09 07 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../../core/model/errors/conversions/ValidationResultConverter");

var SiteReleaseTerminationItem_1 = require("../../model/price-termination/SiteReleaseTerminationItem");

var SiteReleaseTerminationItemConverter_1 = require("./SiteReleaseTerminationItemConverter");
/**
 * @author Jaroslav Sevcik
 */


var SiteReleaseTerminationItemConverterImpl =
/*#__PURE__*/
function (_SiteReleaseTerminati) {
  _inherits(SiteReleaseTerminationItemConverterImpl, _SiteReleaseTerminati);

  function SiteReleaseTerminationItemConverterImpl(validationResultConverter) {
    var _this;

    _classCallCheck(this, SiteReleaseTerminationItemConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseTerminationItemConverterImpl).call(this));
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SiteReleaseTerminationItemConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        terminationId: conversions.toDocumentReferenceId(source.terminationId),
        pExtId: source.pExtId,
        pId: conversions.toDocumentReferenceId(source.pId),
        pName: source.pName,
        sExtId: source.sExtId,
        sId: conversions.toDocumentReferenceId(source.sId),
        sName: source.sName,
        pValidTo: conversions.fromDate(source.pValidTo),
        readonly: source.readonly,
        terminate: source.terminate,
        validation: this.validationResultConverter.toDocument(source.validation, conversions),
        exportResult: this.validationResultConverter.toDocument(source.exportResult, conversions)
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SiteReleaseTerminationItem_1.SiteReleaseTerminationItem(conversions.documentToClassId(source), conversions.asObject(source, 'terminationId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'pExtId', function (v) {
        return v;
      }), conversions.asObject(source, 'pId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'pName', function (v) {
        return v;
      }), conversions.asObject(source, 'sExtId', function (v) {
        return v;
      }), conversions.asObject(source, 'sId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'sName', function (v) {
        return v;
      }), conversions.asObject(source, 'pValidTo', function (v) {
        return conversions.toDate(v);
      }), conversions.asObject(source, 'readonly', function (v) {
        return v;
      }), conversions.asObject(source, 'terminate', function (v) {
        return v;
      }), conversions.asObject(source, 'validation', function (doc) {
        return _this2.validationResultConverter.toObject(doc, conversions);
      }), conversions.asObject(source, 'exportResult', function (doc) {
        return _this2.validationResultConverter.toObject(doc, conversions);
      }));
    }
  }]);

  return SiteReleaseTerminationItemConverterImpl;
}(SiteReleaseTerminationItemConverter_1.SiteReleaseTerminationItemConverter);

SiteReleaseTerminationItemConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ValidationResultConverter_1.ValidationResultConverter])], SiteReleaseTerminationItemConverterImpl);
exports.SiteReleaseTerminationItemConverterImpl = SiteReleaseTerminationItemConverterImpl;